import { Link } from 'react-router-dom';
import { sidebarForArea, articleHref } from '../lib/content-loader';
import './HomePage.css';

export function HomePage() {
  return (
    <>
      <div className="ds-breadcrumb">
        <Link to="/">Docs</Link>
      </div>

      <section className="ds-hero">
        <div className="ds-hero-eyebrow">schedata documentation</div>
        <h1>Build data architecture, intelligently.</h1>
        <p>
          Everything you need to design, version, and ship database schemas with
          Schedata — from your first table to your hundredth migration.
        </p>
      </section>

      <h2 className="ds-home-section-title">Browse by topic</h2>
      <div className="ds-cat-grid">
        {sidebarForArea('docs').map(section => {
          const first = section.articles[0];
          if (!first) return null;
          return (
            <Link key={section.id} to={articleHref(first)} className="ds-cat">
              <div className="ds-cat-head">
                <i className={`fa-solid ${section.icon}`}></i>
                <div className="ds-cat-title">{section.title}</div>
              </div>
              <div className="ds-cat-summary">
                {section.articles.length}{' '}
                {section.articles.length === 1 ? 'article' : 'articles'}
              </div>
              <div className="ds-cat-articles">
                {section.articles.slice(0, 4).map(a => (
                  <span key={a.slug} className="ds-cat-article">
                    {a.title}
                  </span>
                ))}
              </div>
            </Link>
          );
        })}
      </div>

      <h2 className="ds-home-section-title">Build on Schedata</h2>
      <div className="ds-cat-grid">
        <Link to="/api/api-overview" className="ds-cat">
          <div className="ds-cat-head">
            <i className="fa-solid fa-code"></i>
            <div className="ds-cat-title">API Reference</div>
          </div>
          <div className="ds-cat-summary">
            REST endpoints, MCP tools, and token scopes
          </div>
          <div className="ds-cat-articles">
            <span className="ds-cat-article">Authentication</span>
            <span className="ds-cat-article">Quickstart</span>
            <span className="ds-cat-article">REST API endpoints</span>
            <span className="ds-cat-article">MCP tools</span>
          </div>
        </Link>
      </div>
    </>
  );
}
